exports.init = function($) {
    $(document).ready(function() {
        
        jQuery('.related-recipe .boxes').slick({
            infinite: true,
            rows: 0,
            slidesToShow: 2,
            slidesToScroll: 2,
            responsive: [{
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            }]
        });


        var page = 1;

        $(document).on('click', '#load-btn-recipe', function(e) {
            e.preventDefault();
            get_recipe(false);
        });
        $(document).on("click", ".filter__item", function() {
            $(".filter .filter__item").removeClass("active");
            $(this).addClass("active");
            page = 1;
            get_recipe(true);
            return false;
        });
        $(document).on("propertychange change click keyup input paste", "#filter_search input", function() {
            if($(this).val()!=""){
                $(".filter .filter__item").removeClass("active");
                get_recipe(true);
                page = 1;
            }
            return false;
        });

        function get_recipe(filter) {
            var category = $(".filter .filter__item.active").attr("id");
            var search = $("#filter_search input").val();
            if (filter === false) {page++;}
            $.ajax({
                type: 'POST',
                url: '/wp-admin/admin-ajax.php',
                dataType: 'json',
                data: {
                    'action': 'get_recipe',
                    'get_page': page,
                    'get_category': category,
                    'get_search': search,
                },
                success: function(data) {
                    if (filter === false) $('.load-more-content').append(data.recipes);
                    if (filter === true) $('.load-more-content').html(data.recipes);
                    if (data.count === 0) {
                        $(".load-btn-wrap").hide();
                    } else {
                        $(".load-btn-wrap").show();
                    }
                },
                error: function(data) {
                    console.log(data);
                }
            });
            return false;
        }
    });
    /*
    jQuery(window).resize(function () {
  
    });*/

};